const NS = 'SiteEmailSubscribeWidget';
const CLS = 'siteEmailSubscribeWidget';

export class SiteEmailSubscribeWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$inputContainer = this.$element.find(`.${CLS}-inputContainer`);
		this.$input = this.$element.find(`.${CLS}-input`);

		this.$input.focus(() => {
			this.$inputContainer.addClass('focus');
		});

		this.$input.blur(() => {
			this.$inputContainer.removeClass('focus');
		});
	}
}
